import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../Button';
import { SvgIcon } from '../../Icon';
import { IButtonAnalyticsProps } from '../../Button/types';

interface IProps extends IButtonAnalyticsProps {
  label: string;
  onClick: () => void;
  isGreyedOut: boolean;
  disabled: boolean;
}

const FullWidthAction = styled(PrimaryButton)`
  width: 100%;
  height: 36px;
  border-radius: 0 0 3px 3px;
`;

const ExecuteAction = forwardRef<HTMLButtonElement, IProps>(
  (
    { label, onClick, isGreyedOut, disabled, trackContext, trackAction },
    ref,
  ) => (
    <FullWidthAction
      ref={ref}
      type="button"
      onClick={onClick}
      disabled={disabled}
      isGreyedOut={isGreyedOut}
      trackContext={trackContext}
      trackAction={trackAction}
    >
      <SvgIcon
        name="play-fill"
        width={8}
        height={8}
        customFill="currentColor"
      />
      {label}
    </FullWidthAction>
  ),
);

export default ExecuteAction;
